export default __webpack_public_path__ + "static/media/cardActivationhelp@2x.0f5295e9.png";